import React, {Component} from "react";
import {AppRow} from "../components/components";
import {getCountyKey, imagetoCanvasPosHelper} from "../utils/map_utils";
import {styled} from '@mui/material/styles';
import {Grid, Stack} from "@mui/material";
import Tooltip, {tooltipClasses} from '@mui/material/Tooltip';

const CustomWidthTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 500,
  },
});

class ImageMapPos extends Component {

	constructor(props) {
		super(props);

		this.state = {
			imageCoordinate: [-1, -1],
			islandId: "none",
			take1IslandID: "none",
			take2IslandID: "none",
			XYMapPosition: "",
			motorPos: "",
			scanCell: [],
			islandData: [],
			deviceData: [],
		};
	}

	componentDidMount() {
		this.props.map.addEventListener('pointermove', this.onMouseMove);
	}

	componentWillUnmount() {
		this.props.map.removeEventListener('pointermove', this.onMouseMove);
	}

	onMouseMove = (e) => {
		let {pathUnitMap, islands, deviceSettings} = this.props;
		this.scanCell = pathUnitMap?.scanCellMap;
		this.islandData = islands;
		this.deviceData = deviceSettings;
		let slide = this.props.slide;
		let {x_fields, y_fields, tile_width, tile_height, uperpixel} = slide;
		let xVal = Math.floor((e.coordinate[0]) / (tile_width * uperpixel));
		let yVal = y_fields - Math.floor((e.coordinate[1]) / (tile_height * uperpixel)) - 1;

		let islandID = -1, take1IslandID = -1, take2IslandID = -1;
		if (this.islandData?.length > 0 && this.islandData[0]["counties"]) {
			for (let i = 0; i < this.islandData.length; i++) {
				for (let idx = 0; idx < this.islandData[i]["counties"].length; idx++) {
					const countryBoundary = this.islandData[i]["counties"][idx]["countyBoundary"];
					let rectStartPoint = imagetoCanvasPosHelper({device_settings: this.deviceData},
						slide, x_fields - countryBoundary["x"], countryBoundary["y"]);
					let rectEndPoint = imagetoCanvasPosHelper({device_settings: this.deviceData}, slide,
						x_fields - countryBoundary["x"] - countryBoundary["width"],
						countryBoundary["y"] + countryBoundary["height"]);
					let lowerBoundX = Math.min(rectStartPoint.x, rectEndPoint.x);
					let higherBoundX = Math.max(rectStartPoint.x, rectEndPoint.x);
					let lowerBoundY = Math.min(rectStartPoint.y, rectEndPoint.y);
					let higherBoundY = Math.max(rectStartPoint.y, rectEndPoint.y);

					if (e.coordinate[0] >= lowerBoundX && e.coordinate[0] <= higherBoundX &&
						e.coordinate[1] >= lowerBoundY && e.coordinate[1] <= higherBoundY) {
						if (this.islandData[i]["islandKey"]["takeNumber"] === 2) {
							take2IslandID = getCountyKey(this.islandData[i]["islandKey"],
								this.islandData[i]["counties"][idx]["countykey"]["countyId"]);
						}
						if (this.islandData[i]["islandKey"]["takeNumber"] === 1) {
							take1IslandID = getCountyKey(this.islandData[i]["islandKey"],
								this.islandData[i]["counties"][idx]["countykey"]["countyId"]);
						}
						if (this.islandData[i]["islandKey"]["takeNumber"] === 0) {
							islandID = getCountyKey(this.islandData[i]["islandKey"],
								this.islandData[i]["counties"][idx]["countykey"]["countyId"]);
						}
						break;
					}
				}
			}
		} else {
			for (let i = 0; i < (this.islandData || {}).length; i++) {
				let rectStartPoint = imagetoCanvasPosHelper({device_settings: this.deviceData},
					slide, this.islandData[i]["islandBoundary"]["x"],
					y_fields - this.islandData[i]["islandBoundary"]["y"]);
				let rectEndPoint = imagetoCanvasPosHelper({device_settings: this.deviceData}, slide,
					this.islandData[i]["islandBoundary"]["x"] + this.islandData[i]["islandBoundary"]["width"],
					y_fields - this.islandData[i]["islandBoundary"]["y"] -
					this.islandData[i]["islandBoundary"]["height"]);
				let lowerBoundX = Math.min(rectStartPoint.x, rectEndPoint.x);
				let higherBoundX = Math.max(rectStartPoint.x, rectEndPoint.x);
				let lowerBoundY = Math.min(rectStartPoint.y, rectEndPoint.y);
				let higherBoundY = Math.max(rectStartPoint.y, rectEndPoint.y);

				if ((e.coordinate[0] >= lowerBoundX && e.coordinate[0] <= higherBoundX &&
					e.coordinate[1] >= lowerBoundY && e.coordinate[1] <= higherBoundY)) {
					islandID = this.islandData[i]["id"];
					break;
				}
			}
		}

		this.setState({
			imageCoordinate: [xVal, yVal],
			islandId: islandID,
			take1IslandID: take1IslandID,
			take2IslandID: take2IslandID
		});
	}

	render() {
		let imageCoordinate = this.state.imageCoordinate;
		let {x_fields, y_fields} = this.props.slide;
		if (imageCoordinate) {
			if (imageCoordinate[0] >= 0 && imageCoordinate[0] < x_fields &&
				imageCoordinate[1] >= 0 && imageCoordinate[1] < y_fields) {
				this.XYMapPosition = "x" + imageCoordinate[0] + "y" + imageCoordinate[1];
			}
		}
		if (this.scanCell) {
			this.motorPos = this.scanCell[this.XYMapPosition] ?
				this.scanCell[this.XYMapPosition]['position']['xPosition'] + " " +
				this.scanCell[this.XYMapPosition]['position']['yPosition'] : "NA";
		}
		let logs = [];
		if (this.props.scanFocusDebug !== undefined && this.props.scanFocusDebug['debugUnitMap'] !== undefined) {

			for (const [key, value] of Object.entries(this.props.scanFocusDebug['debugUnitMap'])) {
				if (key === this.state.islandId) {
					for (const log of value["logs"]) {
						logs.push(<Grid>{log}</Grid>);
					}
				}
			}
		}
		let popupText = (
			<Stack style={{'width': '500px'}}>
				{logs}
			</Stack>
		);
		if (logs.length === 0) {
			logs.push(<Grid>No logs for the current Island ID</Grid>);
		}
		return <div align={"right"}>
			<AppRow title={"XY Position"}
					value={this.XYMapPosition}/>
			<AppRow title={"Motor Position"}
					value={this.motorPos}/>
			<AppRow title={"Island ID"}
					value={this.state.islandId}/>
			<AppRow title={"Take 1 Island ID"}
					value={this.state.take1IslandID}/>
			<AppRow title={"Take 2 Island ID"}
					value={this.state.take2IslandID}/>
			<AppRow title={"Focus Debug Log"} 
				value={
					<CustomWidthTooltip title={popupText} placement="right">
						<Grid>Hover for Log</Grid>
					</CustomWidthTooltip>
			}/>
			
		</div>
	}
}

export default ImageMapPos;
